/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Modal,
} from 'antd';
import { formatReceived } from 'utils/formatValues';
import { onError } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import {
  getTarifasISRTipoNominaEmpleado,
  getTarifaISRTipoNominaEmpleado,
  postTarifaISRTipoNominaEmpleado,
  patchTarifaISRTipoNominaEmpleado,
  deleteTarifaISRTipoNominaEmpleado,
} from 'api/estructuraOrganizacional/tarifaISRTipoNominaEmpleado';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import { getPermisos } from 'api/usuarios';
import { useDispatch, useSelector } from 'react-redux';
import { selectPermisos } from 'store/catalogos';
import { checkToken } from 'api/utils';
import { FLOAT_NUMER_PATTERN } from 'utils/patterns';
import Select from 'components/Select';
import { getEstadosGlobales } from 'api/catalogos/index';
import {
  ESTATUS_AUTORIZADO, ESTATUS_ACTIVO,
} from 'utils/constants';

export const rolesPermission = {
  permissionModel: 'tarifaisrtipodenominaempleado',
  catalogsModels: [],
};

/* eslint-disable react/prop-types */
const TarifaISRTipoEmpleado = ({
  permission,
  tarifaISR,
  disableControls,
  estatus,
}) => {
  const dispatch = useDispatch();
  const permisos = useSelector(selectPermisos);
  const [form] = Form.useForm();
  const [formDatos] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [tiposNominasEmpleados, setTiposNominasEmpleados] = useState([]);
  const [estados, setEstados] = useState([]);
  const [tipoNominaEmpleadoDelete, setTipoNominaEmpleadoDelete] = useState();
  const [tiposNominasEmpleadoFiltered, setTiposNominasEmpleadoFiltered] = useState();

  const formInstances = [
    form,
    formDatos,
  ];

  const fetchData = async () => {
    setLoading(true);
    const _data = await getTarifasISRTipoNominaEmpleado({ tarifa_isr: tarifaISR });
    setData(_data);
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _tiposNominasEmpleados,
        _estados,
        _data,
      ] = await Promise.all([
        getTiposDeNominasEmpleados({ estados_globales: ESTATUS_AUTORIZADO }),
        getEstadosGlobales(),
        getTarifasISRTipoNominaEmpleado({ tarifa_isr: tarifaISR }),
        getPermisos(dispatch, permisos),
      ]);
      if (mounted) {
        setTiposNominasEmpleados(_tiposNominasEmpleados);
        setEstados(_estados);
        setData(_data);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setTiposNominasEmpleadoFiltered(tiposNominasEmpleados.filter((tne) => !data.some((val) => tne?.id === val?.tipo_de_nomina_empleado)));
    setVisible(false);
    form.resetFields();
    setSelectedRowKeys([]);
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const tarifaTipoNominaEmpleado = await getTarifaISRTipoNominaEmpleado(match.id);
    setTimeout(() => {
      if (tarifaTipoNominaEmpleado) {
        form.resetFields();
        formDatos.resetFields();
        setTimeout(() => {
          setTiposNominasEmpleadoFiltered(tiposNominasEmpleados.filter((tne) => !data.some((val) => {
            if (tne?.id === tarifaTipoNominaEmpleado?.tipo_de_nomina_empleado) {
              return false;
            }
            return tne?.id === val?.tipo_de_nomina_empleado;
          })));
          form.setFieldsValue(formatReceived(tarifaTipoNominaEmpleado));
          formDatos.setFieldsValue(formatReceived(tarifaTipoNominaEmpleado));
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      await formDatos.validateFields();
      const values = {
        ...form.getFieldsValue(),
        ...formDatos.getFieldsValue(),
      };
      const [key] = selectedRowKeys;
      // eslint-disable-next-line max-len
      const saved = await (key ? patchTarifaISRTipoNominaEmpleado(key, { ...values, tarifa_isr: tarifaISR }) : postTarifaISRTipoNominaEmpleado({ ...values, tarifa_isr: tarifaISR }));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    if (selectedRowKeys.length) {
      const [key] = selectedRowKeys;
      const deleted = await deleteTarifaISRTipoNominaEmpleado(key);
      if (deleted) {
        setVisibleAlert(false);
        onCancel();
        await fetchData();
      }
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setTimeout(() => {
      form.setFieldsValue(record);
    });
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setTipoNominaEmpleadoDelete(tiposNominasEmpleados.find((desc) => desc.id === form.getFieldValue('tipo_de_nomina_empleado'))?.descripcion);
    setVisibleAlert(true);
  };

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    valor: [
      requiredRule,
      {
        pattern: FLOAT_NUMER_PATTERN,
        message: 'Ingrese un valor válido',
      },
    ],
  };

  const columns = [
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipo_de_nomina_empleado',
      key: 'tipo_de_nomina_empleado',
      render: (val) => tiposNominasEmpleados.find((tne) => tne.id === val)?.descripcion,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 100,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          mobileCols={columns}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          allowDoubleClick={estatus === ESTATUS_AUTORIZADO || estatus === ESTATUS_ACTIVO}
          controls={{
            onClickAdd,
            onClickEdit,
            onClickDelete,
          }}
          disableAdd={disableControls}
          disableEdit={disableControls}
          disableDelete={disableControls}
          permission={permission}
          allowExportPDF={false}
        />
        <Modal
          open={open}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Tipo de Nómina Empleado`}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
            />
            )}
          onCancel={onCancel}
          forceRender
          width="45%"
        >
          <Form
            layout="vertical"
            form={form}
            onFinish={() => onFinish()}
            scrollToFirstError
          >
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                allowClear
                name="tipo_de_nomina_empleado"
                rules={rules.valor}
                label="Tipo de Nómina Empleado"
                hasFeedback
              >
                <Select
                  dataSource={tiposNominasEmpleadoFiltered}
                  allowClear
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="estados_globales"
                label="Estatus"
                rules={rules.estatus}
                hasFeedback
                initialValue={1}
              >
                <Select
                  labelProp="descripcion"
                  keyProp="id"
                  dataSource={estados}
                  disabled={selectedRowKeys.length <= 0}
                />
              </Form.Item>
            </Col>
            <Form.Item hidden>
              <Button htmlType="submit" />
            </Form.Item>
          </Form>
        </Modal>
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Tipo de Nómina Empleado ${tipoNominaEmpleadoDelete}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default TarifaISRTipoEmpleado;
